import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import PGALogo from '../../images/pga-logo.png'
import FGLogo from '../../images/fg-logo.png'
import JRLLogo from '../../images/jrl-logo-new.png'

const useStyles = makeStyles((theme) => ({
  productsCopy: {
    color: theme.palette.text.secondary,
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '24px',
  },
}))

const ProductMarketingPromo = () => {
  const classes = useStyles()
  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Box mb={1}>
        <Typography className={classes.productsCopy}>One account for all your PGA products</Typography>
      </Box>
      <Box display="flex" alignItems="center">
        <Box mr={2}>
          <img style={{ width: '86px' }} src={PGALogo} alt="PGA of America logo" />
        </Box>
        <Box mr={2}>
          <img style={{ width: '66px' }} src={JRLLogo} alt="PGA Junior League logo" />
        </Box>
        <Box>
          <img style={{ width: '74px' }} src={FGLogo} alt="PGA Family Golf logo" />
        </Box>
      </Box>
    </Box>
  )
}

export default ProductMarketingPromo
